// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.875}
      d="M18.3337 7.44313C18.3337 6.93829 18.3337 6.68586 18.2338 6.56898 18.1472 6.46756 18.0173 6.41373 17.8843 6.4242 17.7311 6.43626 17.5526 6.61475 17.1956 6.97173L14.167 10.0003 17.1956 13.0289C17.5526 13.3859 17.7311 13.5644 17.8843 13.5765 18.0173 13.5869 18.1472 13.5331 18.2338 13.4317 18.3337 13.3148 18.3337 13.0624 18.3337 12.5575V7.44313ZM1.66699 8.16699C1.66699 6.76686 1.66699 6.0668 1.93948 5.53202 2.17916 5.06161 2.56161 4.67916 3.03202 4.43948 3.5668 4.16699 4.26686 4.16699 5.66699 4.16699H10.167C11.5671 4.16699 12.2672 4.16699 12.802 4.43948 13.2724 4.67916 13.6548 5.06161 13.8945 5.53202 14.167 6.0668 14.167 6.76686 14.167 8.16699V11.8337C14.167 13.2338 14.167 13.9339 13.8945 14.4686 13.6548 14.939 13.2724 15.3215 12.802 15.5612 12.2672 15.8337 11.5671 15.8337 10.167 15.8337H5.66699C4.26686 15.8337 3.5668 15.8337 3.03202 15.5612 2.56161 15.3215 2.17916 14.939 1.93948 14.4686 1.66699 13.9339 1.66699 13.2338 1.66699 11.8337V8.16699Z"
    />
  </svg>
);
const IconVideoRecorder = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconVideoRecorder;
